import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { CallStatus } from "../typings";
import { RadioButtonChecked } from "@mui/icons-material";
import { formatDuration } from "../utils/format-duration";
import { CallDurationTimer } from "./CallDurationTimer";

interface CallMetaProps {
  callStatus: CallStatus;
  startTime: number;
}

const CallMeta = ({ callStatus, startTime }: CallMetaProps) => {
  const showRecording = callStatus === CallStatus.IN_PROGRESS || callStatus === CallStatus.END;

  const recordingText =
    callStatus === CallStatus.IN_PROGRESS ? "Recording" : "Recording saved";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        paddingBottom: callStatus === CallStatus.END ? '16px' : '24px'
      }}
    >
      <CallDurationTimer
        textProps={{
          sx: {
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: 500,
            color: "#7a7a7a",
          }
        }}
        status={callStatus}
        startTime={startTime}
      />

      {showRecording && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <RadioButtonChecked
            sx={{
              fontSize: "14px",
              color: '#7A7A7A99'
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color : '#7A7A7A99'
            }}
          >
            {recordingText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CallMeta;
